<template>
    <el-dialog
        title="删除钻探任务"
        :visible="dialogVisible"
        width="410px"
        :center="true"
        top="30vh"
        :close-on-click-modal="false"
        :destroy-on-close="true"
        :before-close="cancelCreate"
    >
        <p>当前仅支持删除【未开始】的钻探任务</p>
        <button @click="cancelCreate">我知道</button>
    </el-dialog>
</template>
<script>
export default {
    data() {
        return {
            dialogVisible: false
        }
    },
    methods: {
        cancelCreate() {
            this.dialogVisible = false
        },
        showDeletePrompt() {
            this.dialogVisible = true
        }
    },
}
</script>
<style scoped>
    ::v-deep .el-dialog {
        border-radius: 10px;
    }
    ::v-deep .el-dialog--center .el-dialog__body {
        padding: 0 40px 40px;
        /* background-color: #ff0000; */
    }
    ::v-deep .el-dialog__header {
        padding: 18px 20px;
    }
    ::v-deep .el-dialog__title {
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #181818;
    }
    p {
        margin-top: 22px;
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #181818;
        line-height: 25px;
    }
    button {
        margin: 41px 55px 0;
        width: 220px;
        height: 48px;
        background: #0054A0;
        border-radius: 6px;
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
    }
</style>